import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  heading: {
    paddingBottom: 8,
    marginBottom: 24,
    borderBottom: `1px solid ${token.colorSplit}`
  },
  empty: {
    '.ant-empty-image': {
      height: 117
    },
    '.ant-empty-image svg': {
      width: 187,
      height: 117
    }
  }
}))
